import React, { useState, useEffect } from 'react';
import SalarieForm from './SalarieForm';
import { salarieAPI } from '../services/salaries';
import './SalarieList.css';

const SalarieList = () => {
  const [salaries, setSalaries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingSalarie, setEditingSalarie] = useState(null);

  useEffect(() => {
    fetchSalaries();
  }, []);

  const fetchSalaries = async () => {
    try {
      setLoading(true);
      const data = await salarieAPI.getAll();
      setSalaries(data);
      setError('');
    } catch (error) {
      console.error('Error fetching salaries:', error);
      setError('Failed to load salaries');
    } finally {
      setLoading(false);
    }
  };

  const handleAddSalarie = async (salarieData) => {
    try {
      const newSalarie = await salarieAPI.create(salarieData);
      setSalaries(prev => [newSalarie, ...prev]);
      setShowForm(false);
      setError('');
    } catch (error) {
      console.error('Error adding salarie:', error);
      throw error;
    }
  };

  const handleUpdateSalarie = async (salarieData) => {
    try {
      const updatedSalarie = await salarieAPI.update(editingSalarie.id, salarieData);
      setSalaries(prev => prev.map(s => s.id === editingSalarie.id ? updatedSalarie : s));
      setEditingSalarie(null);
      setShowForm(false);
      setError('');
    } catch (error) {
      console.error('Error updating salarie:', error);
      throw error;
    }
  };

  const handleDeleteSalarie = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce salarié?')) {
      return;
    }

    try {
      await salarieAPI.delete(id);
      setSalaries(prev => prev.filter(s => s.id !== id));
      setError('');
    } catch (error) {
      console.error('Error deleting salarie:', error);
      setError('Failed to delete salarie');
    }
  };

  const handleEdit = (salarie) => {
    setEditingSalarie(salarie);
    setShowForm(true);
  };

  const handleCancelForm = () => {
    setShowForm(false);
    setEditingSalarie(null);
  };

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="salarie-list-container">
      <div className="salarie-list-header">
        <h2>Liste des Salariés</h2>
        <button 
          className="btn-add"
          onClick={() => {
            setShowForm(true);
            setEditingSalarie(null);
          }}
          disabled={showForm}
        >
          Ajouter Salarié
        </button>
      </div>

      {error && (
        <div className="error-message">{error}</div>
      )}

      {showForm && (
        <div className="form-overlay">
          <SalarieForm
            onSubmit={editingSalarie ? handleUpdateSalarie : handleAddSalarie}
            initialData={editingSalarie}
            onCancel={handleCancelForm}
          />
        </div>
      )}

      <div className="salarie-table-container">
        <table className="salarie-table">
          <thead>
            <tr>
              <th>Matricule</th>
              <th>Nom</th>
              <th>A Camion</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {salaries.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">Aucun salarié trouvé</td>
              </tr>
            ) : (
              salaries.map((salarie) => (
                <tr key={salarie.id}>
                  <td>{salarie.matricule}</td>
                  <td>{salarie.nom}</td>
                  <td>{salarie.acamion ? 'Oui' : 'Non'}</td>
                  <td className="actions">
                    <button 
                      className="btn-edit"
                      onClick={() => handleEdit(salarie)}
                    >
                      Modifier
                    </button>
                    <button 
                      className="btn-delete"
                      onClick={() => handleDeleteSalarie(salarie.id)}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SalarieList;
